import React, { useEffect, useId } from 'react';

import { printMissingConfigError, SiteConfigManager } from '@atlas/core';

const initLicense = ({ id, isEnable, licenseId, src }) => {
  /**
   * custom function to load licences script.
   * the loadScript function is not suitable in this case.
   * because when loading the script, you need to transfer additional data attributes
   */
  if (!isEnable || !licenseId) {
    return;
  }
  return new Promise(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'ra-embed-verified-seal';
    script.dataset.id = licenseId;
    script.dataset.target = id;
    script.dataset.model = '2';
    script.src = src;
    document.head.append(script);
  });
};

const ReclameAquiLicense = () => {
  const reclameNodeIdUnique = useId();
  const enableReclameAqui = SiteConfigManager.getConfig(
    'config.config.license.enableReclameAqui',
    false,
  );

  const reclameAquiId = SiteConfigManager.getConfig('config.config.license.reclameAquiId');

  if (enableReclameAqui && !reclameAquiId) {
    printMissingConfigError('config.config.license.reclameAquiId');
  }

  useEffect(() => {
    (async () => {
      await initLicense({
        id: reclameNodeIdUnique,
        isEnable: enableReclameAqui,
        licenseId: reclameAquiId,
        src: 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js',
      });
    })();
  }, []);

  if (!enableReclameAqui || !reclameAquiId) {
    return null;
  }

  return <div className="e-gaming-logo e-gaming-logo--custom" id={reclameNodeIdUnique} />;
};

export default ReclameAquiLicense;
